const initFooterMenu = () => {
  const footerButton = document.querySelector('.view-link');

  if (footerButton) {
    const footerMenu = document.querySelector('.footer__menu-list');

    footerButton.addEventListener('click', function (event) {
      const menuHeight = footerMenu.scrollHeight;

      footerMenu.classList.toggle('footer__menu-list--open');
      footerMenu.style.height = footerMenu.classList.contains(
        'footer__menu-list--open',
      )
        ? `${menuHeight}px`
        : '0';

      footerButton.classList.toggle('view-link--open');
    });

    window.addEventListener(
      'resize',
      function (event) {
        if (this.window.innerWidth >= 960) {
          footerMenu.classList.remove('footer__menu-list--open');
          footerMenu.style.height = 'auto';
          footerButton.classList.remove('view-link--open');
          footerButton.disabled = true;
        } else {
          footerButton.disabled = false;
          footerMenu.style.height = footerMenu.classList.contains(
            'footer__menu-list--open',
          )
            ? `${footerMenu.scrollHeight}px`
            : '0';
        }
      },
      true,
    );
  }
};

export default initFooterMenu;
